'use strict';
var angular: angular.IAngularStatic = require('angular');
let mod = angular.module('appConfig');

mod
    .constant('featuredActionsIcons', getFeaturedActionsIcons())
    .constant('resourceTypeIcons', getResourceTypeIcons())
    .constant('scopesIcons', getScopesIcons())
    .constant('actionIcons', getActionIcons())
    .constant('searchBoxIcons', getSearchBoxIcons())
    .constant('iconSets', getIconSets())
    .constant('selectedIconSet', getSelectedIconSet())
    .constant('topBarIcons', getTopBarIcons())
    .constant('collectionIcons', getCollectionIcons())
    .constant('opacLocations', getOpacLocations())
    .constant('favoritesIcons', getFavoritesIcons())
    .constant('accountIcons', getMyAccountIcons())
    .constant('searchResultsIcons', getSearchResultsIcons())
    .constant('availabilityLineIcons', getAvaLineIcons())
    .constant('loginIcons', getLoginIcons())
    .constant('backToTopIcon', getBackToTopIcon())
    .constant('savedSearches', getSavedSearchesIcons())
    .constant('searchHistory', getSearchHistoryIcons())
    .constant('viewItIcons', getViewItIcons())
    .constant('tagsIcons', getTagsIcons())
    .constant('browseIcons', getBrowseIcons())
    .constant('journalLineIcons', getJournalLineIcons())
    .constant('facetsIcons',getFacetsIcons())
    .constant('signInIcon',getSignInIcon())
    .constant('collectionDiscoveryIcons', getCollectionDiscoveryIcons())
    .constant('errorMessageIcons', getErrorMessageIcons());




function getSelectedIconSet() {
    return getIconSets()[0];
}


function getIconSets() {
    return [
        {
            type: 'svg',
            id: 'mdIcons',
            displayName: 'Material Icons (Default)',
            link: 'https://www.google.com/design/icons/',
            sets: [
                {
                    set: 'hasActivity',
                    file: 'img/svg/has_activity.svg',
                    size: 18
                },
                {
                    set: 'alert',
                    file: 'img/svg/svg-sprite-alert.svg',
                    size: 48
                },
                {
                    set: 'image',
                    file: 'img/svg/svg-sprite-image.svg',
                    size: 48
                },

                {
                    set: 'action',
                    file: 'img/svg/svg-sprite-action.svg',
                    size: 48
                },

                {
                    set: 'content',
                    file: 'img/svg/svg-sprite-content.svg',
                    size: 48
                },
                {
                    set: 'communication',
                    file: 'img/svg/svg-sprite-communication.svg',
                    size: 48
                },
                {
                    set: 'editor',
                    file: 'img/svg/svg-sprite-editor.svg',
                    size: 48
                },
                {
                    set: 'navigation',
                    file: 'img/svg/svg-sprite-navigation.svg',
                    size: 48
                },
                {
                    set: 'content',
                    file: 'img/svg/svg-sprite-content.svg',
                    size: 48
                },
                {
                    set: 'av',
                    file: 'img/svg/svg-sprite-av.svg',
                    size: 48
                },
                {
                    set: 'file',
                    file: 'img/svg/svg-sprite-file.svg',
                    size: 48
                }
                ,
                {
                    set: 'hardware',
                    file: 'img/svg/svg-sprite-hardware.svg',
                    size: 48
                }
                ,
                {
                    set: 'maps',
                    file: 'img/svg/svg-sprite-maps.svg',
                    size: 48
                }
                ,
                {
                    set: 'notifications',
                    file: 'img/svg/svg-sprite-notification.svg',
                    size: 48
                }
                ,
                {
                    set: 'primo-ui',
                    file: 'img/svg/svg-primo-ui.svg',
                    size: 48
                },
                {
                    set: 'primo-actions',
                    file: 'img/svg/svg-primo-actions.svg',
                    size: 48
                },
                {
                    set: 'primo-resource-type',
                    file: 'img/svg/svg-primo-resource-type.svg',
                    size: 48
                },
                {
                    set: 'content',
                    file: 'img/svg/svg-sprite-content.svg',
                    size: 48
                },
                {
                    set: 'social',
                    file: 'img/svg/svg-sprite-social.svg',
                    size: 48
                }
            ]
        }
        ,
        {
            type: 'svg',
            id: 'iconics',
            displayName: 'Iconic Open',
            link: 'https://useiconic.com/open',
            sets: [
                {
                    set: 'iconic',
                    file: 'path/to/iconic/svg.file',
                    size: 16
                }
            ]
        },
        {
            type: 'font',
            id: 'fontawesome',
            displayName: 'FontAwesome',
            link: 'http://fortawesome.github.io/Font-Awesome/icons/',
            sets: [
                {
                    set: 'fa',
                    file: 'fontawesome',
                    size: ''
                }
            ]
        }
    ];

}

function getBackToTopIcon() {

    let icons = {

        mdIcons:
            {
                backToTop: {
                    type: 'svg',
                    iconSet: 'navigation',
                    icon: 'ic_arrow_upward_24px'
                }
            }

    };
    return icons[getSelectedIconSet().id];
}

function getAvaLineIcons() {

    let icons = {

        mdIcons:
            {
                arrowRight: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'chevron-right'
                },
                externalLink: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'open-in-new'
                },
                onlineMaterial: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'link'
                },
                physicalMaterial: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'book-open'
                },
                helpCircle: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'help-circle-outline'
                },
                pdfLink: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'pdfLink'
                },
                htmlLink: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'htmlLink'
                }
            },
        fontawesome: {
            // icon definitions here
        },
        iconics: {
            // icon definitions here
        }

    };
    return icons[getSelectedIconSet().id];

}

function getSearchResultsIcons() {
    let icons = {

        mdIcons: {
            frbrMultipleIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'multiple-items'
            },
            frbrMultipleLinkArrow: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'chevron-right'
            },
            externaLinkIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'open-in-new'
            },
            questionMarkIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'question-mark'
            },
            closeSideWindow: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'close-side-window'
            },
            raBeta: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'ra-beta'
            }

        },
        fontawesome: {
            frbrMultipleIcon: {
                type: 'svg',
                iconSet: 'content',
                icon: 'ic_content_copy_24px'
            }

        },
        iconics: {

            frbrMultipleIcon: {
                type: 'svg',
                iconSet: 'content',
                icon: 'ic_content_copy_24px'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}


function getJournalLineIcons() {
    let icons = {

        mdIcons: {
            peerreviewed: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'peer-reviewed'
            },
            openaccess: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'open-access'
            },
            course: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'mdi-teach'
            }
        },
        fontawesome: {
            frbrMultipleIcon: {
                type: 'svg',
                iconSet: 'content',
                icon: 'ic_content_copy_24px'
            }

        },
        iconics: {

            frbrMultipleIcon: {
                type: 'svg',
                iconSet: 'content',
                icon: 'ic_content_copy_24px'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}
function getMyAccountIcons() {
    let icons = {
        mdIcons: {
            hasActivityIcon:{
                type: 'svg',
                iconSet: 'hasActivity',
                icon: 'has_activity'
            },
            expandIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'chevron-down'
            }
            ,
            goToStartIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'double-chevron-up'
            },
            checkIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'check-circle'
            }
            ,
            exclamationMarkIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'exclamation-mark'
            }
            ,
            closeReportIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'close-report'
            }
            ,
            expandAllIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'expand-list'
            }
            ,
            collapseAllIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'collapse-list'
            }
            ,
            externalLinkIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'open-in-new'
            }
            ,
            editIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'pencil'
            }
            ,
            discardChangesIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'trash'
            }
            ,
            saveChangesIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'save'
            }
            ,
            renewLoanIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'restore'
            },
            notRenewableIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'lock'
            },
            removeIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'close'
            },
            downloadIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'download'
            },
            timerIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'timer'
            }
            ,
            fineAlertIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'error'
            }
            ,
            requestsAlertIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'bell'
            }
            ,
            messagesAlertIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'flag'
            }
            ,
            arrowRightIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'chevron-right'
            }
            ,
            backToSearch: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'back-to-search'
            },
            emoticonCool: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'emoticon-cool'
            },
            beach: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'beach'
            },
            sun: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'sun'
            },
            beer: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'beer'
            },
            filter: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'filter'
            },
            add: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'plus'
            }
        },
        fontawesome: {
            firstPromoted: {
                type: 'fa',
                icon: 'fa-quote-left'
            }
            ,
            secondPromoted: {
                type: 'fa',
                icon: 'fa-envelope-o'
            }
            ,
            thirdPromoted: {
                type: 'fa',
                icon: 'fa-star'
            }
            ,
            moreActions: {
                type: 'fa',
                icon: 'fa-ellipsis-h'
            }

        },
        iconics: {

            firstPromoted: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'double-quote-sans-left'
            }
            ,
            secondPromoted: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'envelope-open'
            }
            ,
            thirdPromoted: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'bookmark'
            }
            ,
            moreActions: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'ellipses'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getResourceTypeIcons() {
    let icons = {
        mdIcons: {
            all: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'all-magnify'
            },
            archival_materials: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'archival_materials'
            },
            articles: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'articles'
            },
            audios: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'audios'
            },
            blogs: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'blogs'
            },
            book_chapters: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'book_chapters'
            },
            bookreview: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'bookreview'
            },
            books: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'books'
            },
            collections: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'collections'
            },
            computer_files: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'computer_files'
            },
            conference_proceedings: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'conference_proceedings'
            },
            databases: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'databases'
            },
            datasets: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'datasets'
            },
            dissertations: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'dissertations'
            },
            government_documents: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'government_documents'
            },
            images: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'images'
            },
            journals: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'journals'
            },
            kits: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'kits'
            },
            legal_documents: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'legal_documents'
            },
            manuscripts: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'manuscripts'
            },
            maps: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'maps'
            },
            market_researchs: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'market_researchs'
            },
            microform: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'microform'
            },
            newsletterarticle: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'newsletterarticle'
            },
            newspaper_articles: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'newspaper_articles'
            },
            newspapers: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'newspapers'
            },
            other: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'other'
            },
            patents: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'patents'
            },
            realia: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'realia'
            },
            reports: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'reports'
            },
            text_resources: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'text_resources'
            },
            videos: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'videos'
            },
            web_resources: {
                type: 'svg',
                iconSet: 'primo-resource-type',
                icon: 'web_resources'
            }
        }
    };
    return icons[getSelectedIconSet().id];

}


function getFeaturedActionsIcons() {
    let icons = {

        mdIcons: {
            peerreviewed: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'peer-reviewed'
            },
            openaccess: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'open-access'
            },
            course: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'mdi-teach'
            },
            firstPromoted: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'citation'
            }
            ,
            secondPromoted: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'email'
            }
            ,
            thirdPromoted: {
                type: 'svg',
                iconSet: 'action',
                icon: 'ic_bookmark_outline_24px'
            },
            pin: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'prm_pin'
            },
            unPin: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'prm_unpin'
            },
            citationTrailsIn: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'citedBy'
            },
            citationTrailsThis: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'citing'
            },
            citationTrailsListLeftBtn: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'LeftArrow'
            },
            citationTrailsListRightBtn: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'RightArrow'
            },
            moreActions: {
                type: 'svg',
                iconSet: 'navigation',
                icon: 'ic_more_horiz_24px'
            },
            closeActions: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'close'
            },
            email: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'email'
            },
            citations: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'citation'
            },
            chapters: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'chapters'
            },
            reviews: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'reviews'
            },
            fileTree: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'fileTree'
            },
            voiceSearch: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'voiceSearch'
            },
            facetsFilter: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'facetsFilter'
            },
            personalizeResults: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'personalizeResults'
            },
            multipleSelection: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'multipleSelection'
            },
            permalink: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'permalink'
            },
            print: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'print'
            },
            delicious: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'delicious'
            },
            endnote: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'endnote'
            },
            mendeley: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'mendeley'
            },
            easybib: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'easybib'
            },
            refworks: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'refworks'
            },
            ris: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'ris'
            },
            bibtex: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'ris'
            },
            excel: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'excel'
            },
            externalLinkIcon: {
                type: 'svg',
                iconSet: 'action',
                icon: 'ic_open_in_new_24px'
            },
            qr: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'qrCode'
            },
            share: {
                type: 'svg',
                iconSet: 'primo-actions',
                icon: 'share'
            },
            whatsApp: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'whatsApp'
            },
            linkedIn: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'linkedIn'
            },
            twitter: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'twitter'
            },
            facebook: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'facebook'
            }
        },
        fontawesome: {
            firstPromoted: {
                type: 'fa',
                icon: 'fa-quote-left'
            }
            ,
            secondPromoted: {
                type: 'fa',
                icon: 'fa-envelope-o'
            }
            ,
            thirdPromoted: {
                type: 'fa',
                icon: 'fa-star'
            }
            ,
            moreActions: {
                type: 'fa',
                icon: 'fa-ellipsis-h'
            }

        },
        iconics: {

            firstPromoted: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'double-quote-sans-left'
            }
            ,
            secondPromoted: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'envelope-open'
            }
            ,
            thirdPromoted: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'bookmark'
            }
            ,
            moreActions: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'ellipses'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getScopesIcons() {
    let icons = {

        mdIcons:
            ['action:ic_accessibility_24px', 'action:ic_account_box_24px',
                'action:ic_account_circle_24px', 'action:ic_account_child_24px',
                'action:ic_alarm_add_24px', 'action:ic_alarm_on_24px',
                'action:ic_book_24px', 'action:ic_dashboard_24px',
                'action:ic_description_24px', 'action:ic_face_24px',
                'action:ic_find_in_page_24px',
                'action:ic_grade_24px',
                'action:ic_https_24px',
                'action:ic_history_24px',
                'ic_input_24px',
                'ic_label_outline_24px',
                'ic_launch_24px',
                'ic_lock_open_24px',
                'ic_loyalty_24px'
            ]


        ,
        fontawesome:
            ['action:ic_accessibility_24px', 'action:ic_account_box_24px',
                'action:ic_account_circle_24px', 'action:ic_account_child_24px',
                'action:ic_alarm_add_24px', 'action:ic_alarm_on_24px',
                'action:ic_book_24px', 'action:ic_dashboard_24px',
                'action:ic_description_24px', 'action:ic_face_24px',
                'action:ic_find_in_page_24px',
                'action:ic_grade_24px',
                'action:ic_https_24px',
                'action:ic_history_24px',
                'ic_input_24px',
                'ic_label_outline_24px',
                'ic_launch_24px',
                'ic_lock_open_24px',
                'ic_loyalty_24px'
            ]

        ,
        iconics:

            ['action:ic_accessibility_24px', 'action:ic_account_box_24px',
                'action:ic_account_circle_24px', 'action:ic_account_child_24px',
                'action:ic_alarm_add_24px', 'action:ic_alarm_on_24px',
                'action:ic_book_24px', 'action:ic_dashboard_24px',
                'action:ic_description_24px', 'action:ic_face_24px',
                'action:ic_find_in_page_24px',
                'action:ic_grade_24px',
                'action:ic_https_24px',
                'action:ic_history_24px',
                'ic_input_24px',
                'ic_label_outline_24px',
                'ic_launch_24px',
                'ic_lock_open_24px',
                'ic_loyalty_24px'
            ]


    };
    return icons[getSelectedIconSet().id];
}

function getActionIcons() {

    let icons = {

        mdIcons:
            {
                email: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'email',
                    tooltip: 'fulldisplay.command.email.tooltip'
                },
                citations: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'citation'
                },
                syncIcon: {
                    type: 'svg',
                    iconSet: 'notifications',
                    icon: 'ic_sync_24px'
                },
                permalink: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'permalink'
                },
                print: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'print'
                },
                info: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'info'
                },
                delicious: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'delicious'
                },
                endnote: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'endnote'
                },
                mendeley: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'mendeley'
                },
                easybib: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'easybib'
                },
                refworks: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'refworks'
                },
                ris: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'ris'
                },
                excel: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'excel'
                },
                externalLinkIcon: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_open_in_new_24px'
                },
                qr: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'qrCode'
                },
                share: {
                    type: 'svg',
                    iconSet: 'primo-actions',
                    icon: 'share'
                },
                whatsApp: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'whatsApp'
                },
                linkedIn: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'linkedIn'
                },
                twitter: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'twitter'
                },
                facebook: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'facebook'
                }
            },
        fontawesome: {
            email: {
                type: 'fa',
                icon: 'fa-envelope-o'
            },
            citations: {
                type: 'fa',
                icon: 'fa-quote-left'
            },
            permalink: {
                type: 'fa',
                icon: 'fa-link'
            },
            print: {
                type: 'fa',
                icon: 'fa-print'
            },
            delicious: {
                type: 'fa',
                icon: 'fa-delicious'
            },
            endnote: {
                type: 'fa',
                icon: 'fa-file-o'
            },
            easybib: {
                type: 'fa',
                icon: 'fa-book'
            },
            refworks: {
                type: 'fa',
                icon: 'fa-file-text-o'
            },
            ris: {
                type: 'fa',
                icon: 'fa-share-square-o'
            }
        },
        iconics: {
            email: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'envelope-open'
            },
            citations: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'double-quote-sans-left'
            },
            permalink: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'link-intact'
            },
            print: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'print'
            },
            delicious: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'box'
            },
            endnote: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'briefcase'
            },
            easybib: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'book'
            },
            refworks: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'comment-square'
            },
            ris: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'external-link'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}


function getTopBarIcons() {

    let icons = {

        mdIcons:
            {
                user: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_supervisor_account_24px'
                },
                avatar: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_face_24px'
                },
                language: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_language_24px'
                },
                settings: {
                    type: 'svg',
                    iconSet: 'maps',
                    icon: 'ic_local_library_24px'
                },
                signin: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'sign-in'
                },
                signout: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'sign-out'
                },
                searchMode: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'magnifying-glass'
                },
                eshelfMode: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'prm_pin'
                },
                library: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'account-card-details'
                },
                hamburger: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'hamburger'
                },
                more: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'dots-horizontal'
                }
            },
        fontawesome: {
            user: {
                type: 'svg',
                iconSet: 'action',
                icon: 'ic_supervisor_account_24px'
            },
            language: {
                type: 'svg',
                iconSet: 'action',
                icon: 'ic_language_24px'
            },
            settings: {
                type: 'svg',
                iconSet: 'maps',
                icon: 'ic_local_library_24px'
            },
            signout: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'prm-power'
            },
            searchMode: {
                type: 'svg',
                iconSet: 'action',
                icon: 'ic_search_24px'
            },
            eshelfMode: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'prm_pin'
            }
        },
        iconics: {
            email: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'envelope-open'
            },
            citations: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'double-quote-sans-left'
            },
            permalink: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'link-intact'
            },
            print: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'print'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}


function getCollectionIcons() {

    let icons = {

        mdIcons:
            {
                rightArrow: {
                    type: 'svg',
                    iconSet: 'hardware',
                    icon: 'ic_keyboard_arrow_right_24px'
                },
                leftArrow: {
                    type: 'svg',
                    iconSet: 'hardware',
                    icon: 'ic_keyboard_arrow_left_24px'
                },
                listView: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_view_list_24px'
                },
                gridView: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_view_quilt_24px'
                }
            },
        fontawesome: {
            email: {
                type: 'fa',
                icon: 'fa-envelope-o'
            },
            citations: {
                type: 'fa',
                icon: 'fa-quote-left'
            },
            permalink: {
                type: 'fa',
                icon: 'fa-link'
            },
            print: {
                type: 'fa',
                icon: 'fa-print'
            }
        },
        iconics: {
            email: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'envelope-open'
            },
            citations: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'double-quote-sans-left'
            },
            permalink: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'link-intact'
            },
            print: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'print'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getSavedSearchesIcons() {
    let icons = {

        mdIcons:
            {
                alert: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'bell-outline'
                },
                notAlert: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'mdi-bell-off'
                },
                rss: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'rss'
                },
                unpin: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'pin-off'
                }
            }

    };
    return icons[getSelectedIconSet().id];

}

function getCollectionDiscoveryIcons() {
    let icons = {
        mdIcons:
            {
                gridViewIcon: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_view_module_24px'
                },
                GalleryViewIcon: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_dashboard_24px'
                },
                HeaderHomeIcon: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_home_24px'
                }
            }

    };
    return icons[getSelectedIconSet().id];

}

function getSearchHistoryIcons() {
    let icons = {

        mdIcons:
            {
                remove: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_delete_24px'
                },
                alert: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'bell-outline'
                },
                notAlert: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'mdi-bell-off'
                },
                rss: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'rss'
                },
                pin: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'prm_pin'
                },
                unpin: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'prm_unpin'
                },
                searchHistoryIcon: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'restore'
                }
            }

    };
    return icons[getSelectedIconSet().id];

}
function getTagsIcons() {
    let icons = {

        mdIcons:
            {
                searchTextBox: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'magnifying-glass'
                },
                searchHistoryIcon: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'tag-outline'
                },
                toggleListIcon: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'toggle-list'
                },
                toggleItemsIcon: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'toggle-items'
                },
                editIcon: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'pencil'
                },
                remove: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'remove'
                },
                persistent: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'persistent'
                },
                removePersistent: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'remove-persistent'
                }
            }

    };
    return icons[getSelectedIconSet().id];

}


function getOpacLocations() {

    let icons = {

        mdIcons:
            {
                rightArrow: {
                    type: 'svg',
                    iconSet: 'hardware',
                    icon: 'ic_keyboard_arrow_right_24px'
                },
                leftArrow: {
                    type: 'svg',
                    iconSet: 'hardware',
                    icon: 'ic_keyboard_arrow_left_24px'
                },
                expandIcon: {
                    type: 'svg',
                    iconSet: 'hardware',
                    icon: 'ic_keyboard_arrow_down_24px'
                },
                expandAllIcon: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'expand-list'
                }
                ,
                collapseAllIcon: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'collapse-list'
                },
                filter: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'filter'
                },
                filterOut: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'filterOut'
                },
                close: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'close'
                },
                externalLinkIcon: {
                    type: 'svg',
                    iconSet: 'action',
                    icon: 'ic_open_in_new_24px'
                },
                locate: {
                    type: 'svg',
                    iconSet: 'maps',
                    icon: 'ic_place_24px'
                },
                relatedArrow: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'keyboard-return'
                }
            },
        fontawesome: {
            email: {
                type: 'fa',
                icon: 'fa-envelope-o'
            },
            citations: {
                type: 'fa',
                icon: 'fa-quote-left'
            },
            permalink: {
                type: 'fa',
                icon: 'fa-link'
            },
            print: {
                type: 'fa',
                icon: 'fa-print'
            }
        },
        iconics: {
            email: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'envelope-open'
            },
            citations: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'double-quote-sans-left'
            },
            permalink: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'link-intact'
            },
            print: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'print'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getFavoritesIcons() {

    let icons = {

        mdIcons:
            {
                addLabelTop: {
                    type: 'svg',
                    iconSet: 'notifications',
                    icon: 'ic_more_24px'
                },
                addLabelRecord: {
                    type: 'svg',
                    iconSet: 'navigation',
                    icon: 'ic_more_horiz_24px'
                },
                removeLabel: {
                    type: 'svg',
                    iconSet: 'navigation',
                    icon: 'ic_close_24px'
                }
                ,
                addLabel: {
                    type: 'svg',
                    iconSet: 'content',
                    icon: 'ic_add_24px'
                }
                ,
                favoriteActionsList: {
                    type: 'svg',
                    iconSet: 'navigation',
                    icon: 'ic_more_horiz_24px'
                },
                pin: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'prm_pin'
                },
                unPin: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'prm_unpin'
                },
                labelChecked: {
                    type: 'svg',
                    iconSet: 'navigation',
                    icon: 'ic_check_24px'
                }
            },
        fontawesome: {
            email: {
                type: 'fa',
                icon: 'fa-envelope-o'
            },
            citations: {
                type: 'fa',
                icon: 'fa-quote-left'
            },
            permalink: {
                type: 'fa',
                icon: 'fa-link'
            },
            print: {
                type: 'fa',
                icon: 'fa-print'
            }


        },
        iconics: {
            email: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'envelope-open'
            },
            citations: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'double-quote-sans-left'
            },
            permalink: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'link-intact'
            },
            print: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'print'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}



function getSearchBoxIcons() {


    let icons = {

        mdIcons:
            {
                searchTextBox: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'magnifying-glass'
                },
                filter: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'filter'
                },
                filterClose: {
                    type: 'svg',
                    iconSet: 'primo-ui',
                    icon: 'filterOut'
                }
            },
        fontawesome: {

            searchTextBox: {
                type: 'fa',
                icon: 'fa-search'
            },
            filter: {
                type: 'fa',
                icon: 'fa-search'
            },
            filterClose: {
                type: 'fa',
                icon: 'fa-search'
            }
        },
        iconics: {
            searchTextBox: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'magnifying-glass'
            },
            filter: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'magnifying-glass'
            },
            filterClose: {
                type: 'svg',
                iconSet: 'iconic',
                icon: 'magnifying-glass'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getLoginIcons() {
    let icons = {
        mdIcons: {
            externalLinkIcon: {
                type: 'svg',
                iconSet: 'action',
                icon: 'ic_open_in_new_24px'
            },
            backIcon: {
                type: 'svg',
                iconSet: 'navigation',
                icon: 'ic_chevron_left_24px'
            },
            errorIcon: {
                type: 'svg',
                iconSet: 'alert',
                icon: 'ic_error_24px'
            },
            gotoLinkIcon: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'chevron-right'
            }

        }
    };
    return icons[getSelectedIconSet().id];
}
function getViewItIcons() {
    let icons = {
        mdIcons: {
            authNote: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'auth_note'
            },
            publicNote: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'public_note'
            },
            lock: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'lock_icon'
            },
            registration: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'registration_icon'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getBrowseIcons() {
    let icons = {
        mdIcons: {
            crossRef: {
                type: 'svg',
                iconSet: 'hardware',
                icon: 'ic_keyboard_backspace_24px'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getFacetsIcons() {
    let icons = {
        mdIcons: {
            excludeFacet: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'exclude-facet'
            },
            includeFacet: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'include-facet'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}

function getSignInIcon() {
    let icons = {
        mdIcons: {
            signInToViewPermalimk: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'sign-in-permalink'
            }
        }
    };
    return icons[getSelectedIconSet().id]
}

function getErrorMessageIcons() {
    let icons = {
        mdIcons: {
            errorNoResults: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'error-no-results'
            },
            errorAttention: {
                type: 'svg',
                iconSet: 'primo-ui',
                icon: 'error-attention'
            }
        }
    };
    return icons[getSelectedIconSet().id];
}






// WEBPACK FOOTER //
// ./src/main/webapp/components/appConfig/iconConfig.ts